import { render, staticRenderFns } from "./lightspotDialog.vue?vue&type=template&id=20ca24e0&scoped=true&"
import script from "./lightspotDialog.vue?vue&type=script&lang=js&"
export * from "./lightspotDialog.vue?vue&type=script&lang=js&"
import style0 from "./lightspotDialog.vue?vue&type=style&index=0&id=20ca24e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ca24e0",
  null
  
)

export default component.exports